import { siteLinks } from "../../data/site.js";

export function CallToAction({ compact = false } = {}) {
  return `
    <section class="${compact ? "py-16" : "section-pad"}" aria-labelledby="cta-title">
      <div class="site-container">
        <div class="cta-panel">
          <div>
            <span class="eyebrow eyebrow-light">Conversemos</span>
            <h2 id="cta-title" class="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">Hablemos sobre lo que necesita tu empresa.</h2>
            <p class="mt-4 max-w-2xl text-base leading-7 text-blue-100">Revisamos tu operación, identificamos el mejor punto de partida y te mostramos cómo encaja cada producto.</p>
          </div>
          <a class="button button-light shrink-0" href="${siteLinks.requestDemo}">Solicitar demostración</a>
        </div>
      </div>
    </section>
  `;
}
